import React, { useState } from "react";
import PropTypes from "prop-types";
import { Typography, Alert, Checkbox, Row, Col, Form } from "antd";
import CustomPropTypes from "@/customPropTypes";

const propTypes = {
  disabled: PropTypes.bool,
  data: CustomPropTypes.options,
  meta: PropTypes.shape({
    initial: PropTypes.array,
    touched: PropTypes.bool,
    error: PropTypes.string,
  }).isRequired,
  input: PropTypes.shape({
    onChange: PropTypes.func.isRequired,
    value: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
};

const defaultProps = {
  data: [],
  disabled: false,
};

// an item is considered a child of another item when its subType matches the parent's value
const IncidentCategoryCheckboxGroup = (props) => {
  const { data, disabled, input, meta } = props;
  const { touched, error = "", initial = [] } = meta;

  const [isTouched, setIsTouched] = useState(touched);
  const showError = (isTouched || touched) && error;
  const historicalCategories = data.filter(
    (item) => !item.isActive && initial.includes(item.value)
  );
  const parentCategories = data.filter((item) => item.subType === null && item.isActive);

  const activeCategories = parentCategories.map((category) => {
    const children = data.filter((item) => category.value === item.subType);
    return {
      children,
      ...category,
    };
  });

  const onChange = (checkedValues) => {
    setIsTouched(true);
    input.onChange(checkedValues);
  };

  return (
    <Form.Item validateStatus={showError && "error"} help={showError && <span>{error}</span>}>
      <Checkbox.Group
        onChange={onChange}
        defaultValue={initial}
        disabled={disabled}
      >
        {historicalCategories.length > 0 && (
          <div style={{ border: "1px solid #5e46a1", borderRadius: "3px", padding: "1em 2em" }}>
            <Alert
              message="This incident uses legacy incident types"
              description="Please update this incident with additional categories."
              showIcon
              type="warning"
            />
            <Typography.Text>Legacy Categories</Typography.Text>
            <Row style={{ marginBottom: "15px" }}>
              {historicalCategories.map((category) => {
                return (
                  <Col span={12}>
                    <Checkbox value={category.value}>
                      <b>{category.label}</b>
                    </Checkbox>
                  </Col>
                );
              })}
            </Row>
          </div>
        )}
        <div
          style={{
            columnCount: 2,
            columnGap: 0,
          }}
        >
          {activeCategories.map((category) => {
            return category.children.length > 0 ? (
              <Col
                span={24}
                style={{
                  breakInside: "avoid-column",
                }}
              >
                <Typography.Text>
                  <b>{category.label}</b>
                </Typography.Text>
                {category.children.map((child) => {
                  return (
                    <Row style={{ padding: "6px" }}>
                      <Checkbox value={child.value}>{child.label}</Checkbox>
                    </Row>
                  );
                })}
              </Col>
            ) : (
              <Row
                style={{
                  breakInside: "avoid-column",
                  padding: "6px",
                }}
              >
                <Checkbox value={category.value} style={{ fontSize: "1rem" }}>
                  <b>{category.label}</b>
                </Checkbox>
              </Row>
            );
          })}
        </div>
      </Checkbox.Group>
    </Form.Item>
  );
};

IncidentCategoryCheckboxGroup.propTypes = propTypes;
IncidentCategoryCheckboxGroup.defaultProps = defaultProps;

export default IncidentCategoryCheckboxGroup;
